var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5006 17.0974H17.7106L17.4306 16.8274C18.6306 15.4274 19.2506 13.5174 18.9106 11.4874C18.4406 8.70743 16.1206 6.48743 13.3206 6.14743C9.09063 5.62743 5.53063 9.18743 6.05063 13.4174C6.39063 16.2174 8.61063 18.5374 11.3906 19.0074C13.4206 19.3474 15.3306 18.7274 16.7306 17.5274L17.0006 17.8074V18.5974L21.2506 22.8474C21.6606 23.2574 22.3306 23.2574 22.7406 22.8474C23.1506 22.4374 23.1506 21.7674 22.7406 21.3574L18.5006 17.0974ZM12.5006 17.0974C10.0106 17.0974 8.00063 15.0874 8.00063 12.5974C8.00063 10.1074 10.0106 8.09743 12.5006 8.09743C14.9906 8.09743 17.0006 10.1074 17.0006 12.5974C17.0006 15.0874 14.9906 17.0974 12.5006 17.0974Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.36f88b4b48c3ccff7ef84acf762f035f.svg";
export { ForwardRef as ReactComponent };